import type { ReactNode } from 'react';

export const symbol_format_h6: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M128.5-288.63Q120-297.25 120-310v-340q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v140h180v-140q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v340q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-140H180v140q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM600-280q-24.75 0-42.37-17.63Q540-315.25 540-340v-280q0-24.75 17.63-42.38Q575.25-680 600-680h210q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H600v110h180q24.75 0 42.38 17.62Q840-474.75 840-450v110q0 24.75-17.62 42.37Q804.75-280 780-280H600Zm0-170v110h180v-110H600Z"
		/>
	</svg>
);
